export const SERVICE_URLS = {
  USER_SIGNIN: '/signin',
  COURSES: '/courses',
  COURSES_MY_CATEGORY: '/courses/my-category',
};
